import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
var css = {
  "select": "rui-7DCo7",
  "selectLabel": "rui-Rqxoi",
  "animatedPlaceholder": "rui-c5OuZ",
  "fill": "rui-8sqw4",
  "error": "rui-EaBGj"
};
import classNames from 'classnames';
var icons = {
  "panameraIcons": "rui-CXaZ2",
  "icon-download": "rui-8dADt",
  "icon-arrow-top-left": "rui-WhWIZ",
  "icon-SMS": "rui-9ycrb",
  "icon-more": "rui-RoGpD",
  "icon-circle_stroke": "rui-o40gR",
  "icon-Approved": "rui-0o6Oa",
  "icon-CreditCard": "rui-VjaE1",
  "icon-Cash": "rui-soluw",
  "icon-OK": "rui-Nsj4Z",
  "icon-Tips": "rui-cmNxY",
  "icon-ArrowRight": "rui-FoRP5",
  "icon-ArrowLeft": "rui-gl7Ni",
  "icon-ArrowDown": "rui-oKXO0",
  "icon-ArrowUp": "rui-VwnlQ",
  "icon-Cross": "rui-wKCT9",
  "icon-Menu": "rui-OGAFJ",
  "icon-Location": "rui-BCmOe",
  "icon-Crosshairs": "rui-V6LKP",
  "icon-Classes": "rui-OhNfW",
  "icon-Electronics": "rui-Oeixo",
  "icon-FavoriteOff": "rui-OOUzL",
  "icon-FavoriteOn": "rui-EdJCX",
  "icon-Facebook": "rui-990kR",
  "icon-FacebookProfile": "rui-IQ0fc",
  "icon-FacebookProfileValidated": "rui-Wu3Ns",
  "icon-SendMessage": "rui-lgETM",
  "icon-GoogleProfile": "rui-8yTHq",
  "icon-Zoom": "rui-99cag",
  "icon-GoogleProfileValidated": "rui-qudbD",
  "icon-MakeAnOffer": "rui-X8H5d",
  "icon-Flag": "rui-0nl5f",
  "icon-ShareIt": "rui-bSEwF",
  "icon-PhoneProfile": "rui-Wi0Wu",
  "icon-Back": "rui-XRg9H",
  "icon-PhoneProfileValidated": "rui-2AXnM",
  "icon-Whatsapp": "rui-zIPW5",
  "icon-Messenger": "rui-YtAcL",
  "icon-Home": "rui-0iBIX",
  "icon-Industries": "rui-qt5M6",
  "icon-Instruments": "rui-772Ga",
  "icon-Jobs": "rui-oXsZw",
  "icon-Games": "rui-3CRNc",
  "icon-Animals": "rui-HbcoW",
  "icon-Farming": "rui-7zveZ",
  "icon-Fashion": "rui-EY9uj",
  "icon-RealEstate": "rui-Lm3Dx",
  "icon-Services": "rui-Mn0FQ",
  "icon-ForSale": "rui-Vp6WE",
  "icon-Smartphones": "rui-CdgZ5",
  "icon-Sports": "rui-pmYnj",
  "icon-Furnitures": "rui-QDPYG",
  "icon-Vehicles": "rui-N2xlq",
  "icon-Babies": "rui-uXA4a",
  "icon-Exit": "rui-jVSLp",
  "icon-Edit": "rui-qj8rz",
  "icon-Trash": "rui-AoGmv",
  "icon-Search": "rui-fLpAi",
  "icon-Notifications": "rui-QbqhH",
  "icon-Photo": "rui-IXSRQ",
  "icon-Hot": "rui-oAerh",
  "icon-View": "rui-M7sCx",
  "icon-Chat": "rui-Qq5hb",
  "icon-User": "rui-zoRm8",
  "icon-UserCheck": "rui-hDRqw",
  "icon-Friends": "rui-aoTzZ",
  "icon-Refresh": "rui-UmMHL",
  "icon-ErrorHaired": "rui-NfS0U",
  "icon-OKHaired": "rui-djZy7",
  "icon-AddPhotos": "rui-xL1XO",
  "icon-CrossRounded": "rui-0DkO8",
  "icon-OLX": "rui-4M6XE",
  "icon-EyeOff": "rui-gt2eK",
  "icon-DoubleCheckRead": "rui-qUzGV",
  "icon-attach": "rui-RzBhd",
  "icon-offer": "rui-9rU35",
  "icon-meeting": "rui-xAzJd",
  "icon-iconcategories": "rui-PppAb",
  "icon-sorting": "rui-AQGEL",
  "icon-mobileFilters": "rui-CeN5A",
  "icon-bigView": "rui-xA1mo",
  "icon-gridView": "rui-vhoTR",
  "icon-listView": "rui-ls11x",
  "icon-mic": "rui-JorSl",
  "icon-play": "rui-osBMh",
  "icon-pause": "rui-zGaZx",
  "icon-myads": "rui-TbOkM",
  "icon-unfollow-friend": "rui-QJlAD",
  "icon-call": "rui-pJxSV",
  "icon-twotone-more1": "rui-KgnD4",
  "icon-twotone-nearby": "rui-oYNLf",
  "icon-twotone-sale": "rui-smtGS",
  "icon-twotone-rent": "rui-siMW9",
  "icon-YoutubeProfile": "rui-iE9k9",
  "icon-TwitterProfile": "rui-uvABe",
  "icon-InstagramProfile": "rui-NNOLS",
  "icon-Key": "rui-EykPp",
  "icon-Inventory": "rui-tueft",
  "icon-Draft": "rui-HnQzh",
  "icon-Addcar": "rui-f5omG",
  "icon-Lift": "rui-1oRvV",
  "icon-CarParking": "rui-MLygQ",
  "icon-CCTV": "rui-a0Odn",
  "icon-ClubHouse": "rui-lDwCK",
  "icon-FireAlarm": "rui-iZpAU",
  "icon-Fitness": "rui-3XVWI",
  "icon-Intercom": "rui-PwebR",
  "icon-PlayArea": "rui-AZYPO",
  "icon-PowerBackup": "rui-M6nct",
  "icon-RainWater": "rui-oCoYR",
  "icon-Security": "rui-vgfBT",
  "icon-SwimmingPool": "rui-RWbSj",
  "icon-WaterSupply": "rui-TGTwu",
  "icon-twotone-motorbike": "rui-z6RNS",
  "icon-AttentionHaired": "rui-MH8VD",
  "icon-AddFriend": "rui-0W12u",
  "icon-Filters": "rui-Wv5dr",
  "icon-help-outline": "rui-NRFlq",
  "icon-PremiumFeaturedAd": "rui-IYUBp"
};
var Select = /*#__PURE__*/function (_React$Component) {
  function Select(props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _callSuper(this, Select, [props]);
    _this.state = {
      value: props.selected
    };
    _this.bindings = {
      handleChange: _this.handleChange.bind(_this)
    };
    return _this;
  }
  _inherits(Select, _React$Component);
  return _createClass(Select, [{
    key: "handleChange",
    value: function handleChange(event) {
      var _this2 = this;
      this.setState({
        value: event.target.value
      }, function () {
        var _a, _b;
        (_b = (_a = _this2.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, _this2.state.value, _this2.props.name);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _a;
      var cssClassNames = [css.selectLabel];
      var options = (_a = this.props.options) === null || _a === void 0 ? void 0 : _a.map(function (option, key) {
        return /*#__PURE__*/React.createElement("option", {
          key: key,
          value: option.value
        }, option.text);
      });
      if (options && options.length > 1 || this.props.children && this.props.children.length > 1) {
        cssClassNames.push(icons.panameraIcons, icons['icon-ArrowDown']);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: classNames([css.select, this.props.className, this.props.errorText ? css.error : '', this.state.value && this.state.value.length ? css.fill : '']),
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(cssClassNames)
      }, /*#__PURE__*/React.createElement("select", Object.assign({
        id: this.props.id,
        name: this.props.name,
        value: this.state.value,
        style: this.props.style,
        onChange: this.bindings.handleChange,
        disabled: this.props.disabled,
        onBlur: function onBlur() {}
      }, this.props.extras), this.props.children || options)), /*#__PURE__*/React.createElement("span", {
        className: css.error
      }, this.props.errorText), /*#__PURE__*/React.createElement("label", {
        className: css.animatedPlaceholder
      }, this.props.label));
    }
  }]);
}(React.Component);
Select.defaultProps = {
  onChange: function onChange() {},
  value: '',
  disabled: false,
  className: '',
  id: '',
  name: '',
  style: {},
  options: [],
  selected: '',
  errorText: '',
  label: '',
  extras: {}
};
export default Select;